/**
 * Derive the variant-level Depict `product_id` for a Centra product +
 * currently selected size. Depict ingests products with the size suffix baked
 * into the SKU (e.g. `EITE06103xs` for the XS variant of EITE06103) — exactly
 * what Centra exposes as each item's `sku`.
 *
 * Returns `undefined` until a size matches; callers should treat that as
 * "don't fire the DPC event yet". `SizeSelector` auto-selects the first
 * available size on mount, so this resolves immediately for in-stock products.
 *
 * Kept in its own (non-"use client") file so server components can import it
 * without dragging the DPC client bundle along.
 */
export const getDepictVariantId = (
	items: ReadonlyArray<{ name?: string | null; sku?: string | null }> | null | undefined,
	selectedSize: string | null | undefined,
): string | undefined => {
	if (!selectedSize) return undefined;
	const matched = items?.find((i) => i.name === selectedSize);
	return matched?.sku || undefined;
};
